import { Money } from '@betterment/core';
import { sum } from 'es-toolkit/compat';

import { AmountChoice, OrderUnit } from './types';

type CalculateMoneyAmountInput = AmountChoice & { pricePerShare: Money };

export const calculateMoneyAmount = (values: CalculateMoneyAmountInput): Money => {
  if (values.unit === OrderUnit.Dollars) {
    return values.amount;
  }

  return Money(values.amount * values.pricePerShare.cents);
};

export const isSellingToUnderweight = ({
  securityGroupPositions,
  financialSecurityId,
  sellAmount,
}: {
  securityGroupPositions: Array<{
    currentWeight: number;
    amount: Money;
    isRogueSecurity: boolean;
    securityGroup: {
      targetWeight: number;
    };
    securityPositions: Array<{
      financialSecurity: { id: string };
    }>;
  }>;
  financialSecurityId: string;
  sellAmount: Money;
}): boolean => {
  const targetPosition = securityGroupPositions.find(position =>
    position.securityPositions.some(sp => sp.financialSecurity.id === financialSecurityId)
  );

  if (!targetPosition) return false;
  if (targetPosition.isRogueSecurity) return false;

  const balance = Money(sum(securityGroupPositions.map(position => position.amount.cents)));
  const newBalance = Money(balance.cents - sellAmount.cents);
  const newPositionAmount = Money(targetPosition.amount.cents - sellAmount.cents);

  if (newBalance.cents <= 0) {
    return targetPosition.securityGroup.targetWeight > 0;
  }

  const newWeightPercent = (newPositionAmount.cents / newBalance.cents) * 100;
  return newWeightPercent < targetPosition.securityGroup.targetWeight;
};
